export enum TabNameEnum {
  'all' = 'all',
  'my-cloud' = 'my-cloud',
  'hubs' = 'hubs',
}
